import { HTMLAttributes, FC } from "react";
import clsx from "classnames";
import { TypographyVariant } from "../../../constants/typography";
import { Typography } from "../../core/Typography/Typography";
import { StaticImage } from "../../core/StaticImage/StaticImage";
import GamePad from "../../../assets/console/onmo_controller_1x.webp";
import GamePad2x from "../../../assets/console/onmo_controller_2x.webp";
import GamePad3x from "../../../assets/console/onmo_controller_3x.webp";
import { useStyles } from "./ConsoleDeviceCard.style";
import { map } from "lodash-es";
import { useGamepadContext } from "../../../contexts/GamepadProvider";
import Controller from "../../../assets/console/controller_bg_1x.webp";
import Controller2x from "../../../assets/console/controller_bg_2x.webp";
import Controller3x from "../../../assets/console/controller_bg_3x.webp";
import Keyboard from "../../../assets/console/keyboard_1x.webp";
import Keyboard2x from "../../../assets/console/keyboard_2x.webp";
import Keyboard3x from "../../../assets/console/keyboard_3x.webp";
import { useSelector } from "react-redux";
import { selectHasConnectedMouseKeyboard } from "../../../store/slices/appState";
import { useTranslation } from "react-i18next";

export const ConsoleDeviceCard: FC<HTMLAttributes<HTMLDivElement>> = (
  props,
) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { className, onClick, ...otherProps } = props;
  const { gamepads } = useGamepadContext();
  const hasConnectedMouseKeyboard = useSelector(
    selectHasConnectedMouseKeyboard,
  );
  const gamepadsConnected = gamepads?.filter((gp) => gp.type !== "generic");
  const noDevices = !gamepadsConnected?.length;
  const numberOfDevices =
    (gamepadsConnected?.length || 0) + (hasConnectedMouseKeyboard ? 1 : 0);

  return (
    <div
      {...otherProps}
      className={clsx(classes.root, className, noDevices && classes.noPadding)}
      data-gamepad="controller-card"
      data-selected-class={classes.selected}
      onClick={props.onClick}
    >
      <div className={clsx(noDevices && classes.noDevice)}>
        <Typography
          variant={TypographyVariant.HeadingH5Bold}
          className={clsx(classes.value, noDevices && classes.noDeviceValue)}
        >
          {!noDevices
            ? t("Console_Devices Connected", { count: numberOfDevices })
            : t("Console_Pair your ONMO+ Pro Controller")}
        </Typography>
        {noDevices && (
          <div className={classes.gamepad}>
            <StaticImage
              src={Controller}
              src2x={Controller2x}
              src3x={Controller3x}
              className={classes.imageDevice}
            />
          </div>
        )}
      </div>
      {!noDevices && (
        <div className={classes.options}>
          {hasConnectedMouseKeyboard && (
            <div className={classes.gamePad}>
              <StaticImage
                src={Keyboard}
                src2x={Keyboard2x}
                src3x={Keyboard3x}
                className={classes.image}
              />
            </div>
          )}
          {map(gamepadsConnected, (_, idx) => (
            <div className={classes.gamePad} key={idx}>
              <StaticImage
                src={GamePad}
                src2x={GamePad2x}
                src3x={GamePad3x}
                className={classes.image}
              />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
